import { blankRows, conformRows } from "./grid";
import {
  EMPTY,
  MAX_SIZE,
  type CrosswordDefinition,
  type CrosswordProgress,
  type CrosswordSubmission,
} from "./types";

export function emptyDefinition(): CrosswordDefinition {
  return {
    puzzleType: "crossword",
    typeVersion: 1,
    language: "fr",
    clueLayout: "numbered",
    grid: Array.from({ length: 5 }, () => EMPTY.repeat(5)),
    clues: [],
    rulesText: {},
  };
}

export function clampSize(value: number): number {
  if (!Number.isFinite(value)) return 1;
  return Math.min(MAX_SIZE, Math.max(1, Math.trunc(value)));
}

export function emptyProgress(definition: CrosswordDefinition): CrosswordProgress {
  return { version: 1, rows: blankRows(definition.grid) };
}

/** Accepts any stored blob (older versions, null, garbage) and returns a valid progress. */
export function migrateProgress(definition: CrosswordDefinition, raw: unknown): CrosswordProgress {
  if (typeof raw !== "object" || raw === null || Array.isArray(raw))
    return emptyProgress(definition);
  const source = (raw as { rows?: unknown }).rows;
  if (!Array.isArray(source)) return emptyProgress(definition);
  return { version: 1, rows: conformRows(source, definition.grid) };
}

export function serializeSubmission(
  definition: CrosswordDefinition,
  progress: CrosswordProgress,
): CrosswordSubmission {
  return { rows: conformRows(progress.rows, definition.grid) };
}
